module.exports = __webpack_public_path__ + "static/ernie-and-rachell.a75b8fc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/avatars/ernie-and-rachell.jpg
// module id = 277
// module chunks = 168707334958949